import React from "react";
import Banner from "./Banner";
import Traveller from "./Traveller";
import BlackTitleBar from "./BlackTitleBar";
import StayTouch from "../../layout/StayTouch";
import HowItWorks from "../../layout/HowItWorks";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import Promotion from "../../layout/Promotion";
class GetWifi extends React.Component {
  render() {
    const { type } = this.props.match.params;
    return (
      <div>
        <Banner type={type} />
        <BlackTitleBar />
        <Promotion />
        <Traveller />
        <HowItWorks />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(GetWifi);



// WEBPACK FOOTER //
// ./src/pages/getwifius/index.js